export default __webpack_public_path__ + "static/media/login1.efd371aa.png";